import React from "react";

function About() {
  return (
    <>
      {/* Banner Area */}
      <div className="aon-page-benner-area2">
        <div className="aon-page-banner-row2">
          <div className="aon-page-benner-overlay2" />
          <div className="sf-banner-heading-wrap2">
            <div className="sf-banner-heading-area2">
              {/* <div className="sf-banner-breadcrumbs-nav2">
                <ul className="list-inline">
                  <li>
                    <a href="/"> Home </a>
                  </li>
                  <li>About Us.</li>
                </ul>
              </div> */}
              <div className="sf-banner-heading-large2">About Us</div>
            </div>
            {/* <div className="sf-banner-vid-section">
              <div className="video-play-btn2">
                <a
                  className="mfp-video"
                  href="https://www.youtube.com/watch?v=c1XNqw2gSbU"
                >
                  <i className="fa fa-play" />
                </a>
                <span>
                  Watch Now <br />
                  Companey Details
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* Banner Area End */}
      <section className="aon-about-area remove-bot-padding">
        <div className="site-top-line" />
        <div className="container">
          {/*Title Section Start*/}
          <div className="section-head center">
            <span className="aon-sub-icon">
              <img src="images/icon.png" alt="" />
            </span>
            <h2 className="aon-title aon-title-line">
              Welcome to <span>Mahalaxmi</span> Oil Mill
            </h2>
            <p>
              The demand for cattle feed supplements has grown considerably over
              a long time. This research compelled us to launch our venture,
              Mahalaxmi Oil Mill in the market. Over the last couple of years we
              have produced and served many customers with the best quality
              Cattle Feed Supplements. Based in Dhansura, Gujarat, India, the
              range which we cater to the customers comprises of Cattle Feed Mix
              Pashu Aahaar, Cattle Feed Pellets, Makai Bhardo and various
              others. All of our goods are manufactured in compliance with the
              highest quality standards which is what makes them nutritious and
              healthy for the animals. This has always brought our company
              higher success, but we don't stop here, our goal is to achieve the
              top market position.
            </p>
          </div>
          {/*Title Section End*/}
          <div className="section-content">
            <div className="about-year-top d-flex justify-content-center align-items-center">
              <div className="about-year-since">Since 2006</div>
              <div className="about-year-pic">
                {/* <img src="images/about.png" alt="" /> */}
                -
              </div>
              <div className="about-year-sign">
                <img src="images/sign2.png" alt="" />
              </div>
            </div>
          </div>
          {/*Welcome Pic Circle*/}
          <div className="aon-welcome-pic">
            <img src="images/circle-pic.png" alt="" />
          </div>
        </div>
      </section>
      {/* About 2 Section */}
      <section className="aon-about-area">
        <div className="container">
          <div className="section-content">
            <div className="row">
              {/* Column 1 */}
              <div className="col-lg-6">
                <div className="aon-product-left2">
                  <div className="aon-pro-pic">
                    <img src="images/about2.jpeg" alt="" />
                    <div className="aon-pro-get-to d-flex align-items-center">
                      <div className="aon-pro-get-left">
                        <span>Call to get us.</span>
                        <strong><a style={{color: 'white'}} href="tel:08045803774">+91 8045803774</a></strong>
                      </div>
                      <div className="aon-pro-get-right">
                        <div className="aon-pro-get-icon">
                          <i className="fa fa-phone" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Column 2 */}
              <div className="col-lg-6">
                <div className="aon-product-right2">
                  <span className="aon-sub-title">Who we are?</span>
                  <h2 className="aon-pro-title">
                    We provide high quality cattle feeds.
                  </h2>
                  <div className="aon-pro-tagline2">
                  We are a leading manufacturer and supplier of high-quality Cattle Feed Supplements, catering to the growing demand for nutritious animal nutrition. With our vast experience in the industry since 2006, we have established ourselves as a trusted name in providing superior feeds to enhance the health and well-being of cattle.
                  </div>
                  <p>
                  At Mahalaxmi Oil Mill, we understand the importance of animal nutrition and the impact it has on their growth and productivity. That's why we are committed to producing a diverse range of Cattle Feed Supplements, including our popular products like Cattle Feed Mix Pashu Aahaar, Coconut Cattle Feed, and Cattle Feed Mix. These feeds are formulated using the finest raw materials, ensuring their highest quality and nutritional value.
                  </p>
                  <p>
                  Our success can be attributed to our dedicated and knowledgeable team of 500+ employees, who work tirelessly to ensure every aspect of our production process is executed with utmost precision. They adhere to the highest corporate principles and standards, guaranteeing the delivery of an exceptional product line that consistently meets the expectations of our valued customers.
                  </p>
                  <p>
                  Customer satisfaction is at the core of our business philosophy. We take pride in the fact that our products have been widely appreciated by customers across the market. We strive to provide the best-in-class Cattle Feed Supplements that not only nourish the animals but also contribute to their overall health and performance.
                  </p>
               
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <div className="aon-pro-box">
                        <div className="aon-pro-icon">
                        <img src="images/animal-feed-icon.png" />
                        </div>
                        <h4 className="aon-pro-title2">
                          Organic <br />
                          Cattle Feed
                        </h4>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="aon-pro-box">
                        <div className="aon-pro-icon">
                        <img src="images/milk.png" />
                        </div>
                        <h4 className="aon-pro-title2">
                          Natural <br />
                          Milk
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-bot-line" />
        <h1 className="aon-title aon-title-line m-5" style={{color: 'grey'}}>
            Choose Mahalaxmi Oil Mill for <b style={{color: 'green'}}>Superior Quality Cattle Feed Supplements</b>  that you can trust. Join our ever-growing list of satisfied customers and give your cattle the nutrition they deserve. <br></br>Contact us today to experience the difference!
            </h1>
      </section>
      {/* About 2 Section */}
  
      <section
        className="aon-vodeo-area position-relative"
        style={{ backgroundImage: "url(images/award.JPG)", backgroundSize: 'cover' }}
      >
        <div className="aon-overlay-area" />
        <div className="container">
          {/*Title Section Start*/}
          <div className="aon-vodeo-section text-center">
            <h2 className="aon-vodeo-title">
What we have deserved?            </h2>
            <div className="play-now-statice">
              <a
                href="https://www.youtube.com/watch?v=b-aMq7XejOE"
                className="mfp-video play-now-video play-now-statice"
                target="_blank"
              >
                <i className="icon fa fa-play" />
                <span className="ripple" />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Video Section End */}
      {/* Services Section */}
      <section className="aon-service-area2">
        <div className="site-top-line" />
        <div className="container">
          {/*Title Section Start*/}
          <div className="section-head center">
            <span className="aon-sub-title">Know us</span>
            <h2 className="aon-title">Key Facts of Mahalaxmi Oil Mill</h2>
          </div>
          {/*Title Section End*/}
          <div className="section-content">
            <div className="aon-service-section">
              <div className="owl-carousel aon-services-slider aon-owl-arrow">
                <div className="item">
                  <div className="aon-service-box">
                   
                    <div className="aon-service-pic">
                    <div style={{ textAlign: "justify" }}>
  <table width="100%" cellSpacing={0} cellPadding={4}>
    {" "}
    <colgroup>
      <col width="128*" /> <col width="128*" />{" "}
    </colgroup>
    <tbody>
      <tr valign="top">
        <td
          style={{
            borderColor: "#000000 currentcolor #000000 #000000",
            borderStyle: "solid none solid solid",
            borderWidth: "1px medium 1px 1px",
            padding: "0.1cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Nature of Business</p>
        </td>
        <td
          style={{ border: "1px solid #000000", padding: "0.1cm" }}
          width="50%"
        >
          <p>Manufacturer and Supplier</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Year of Establishment</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>2006</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> No. of Employees</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>50</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> No. of Designers</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>02</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> No. of Engineers</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>02</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> No. of Production Unit</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>03</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Brand Name</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>Mewad King</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Monthly Production Capacity</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>6000 MT</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Banker</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>State Bank of India</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Company Branches</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>02</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> GST No.</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>24AAYFM2388K1ZI</p>
        </td>
      </tr>
      <tr valign="top">
        <td
          style={{
            borderColor: "currentcolor currentcolor #000000 #000000",
            borderStyle: "none none solid solid",
            borderWidth: "medium medium 1px 1px",
            padding: "0cm 0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p> Ownership Type</p>
        </td>
        <td
          style={{
            borderColor: "currentcolor #000000 #000000",
            borderStyle: "none solid solid",
            borderWidth: "medium 1px 1px",
            padding: "0cm 0.1cm 0.1cm"
          }}
          width="50%"
        >
          <p>Partnership</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

                    </div>
                  </div>
                </div>
                {/* COLUMNS 2 */}
                <div className="item">
                  <div className="aon-service-box">
                    <div className="aon-service-content">
                      <h4 className="aon-service-title">Who is happy with us?</h4>
                      {/* <p>
                        Know More
                      </p> */}
                    </div>
                    <div className="aon-service-pic">
                      <img src="images/cows.jpeg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
    </>
  );
}

export default About;
